import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'amfori_client_id'

export const dataPointDefinition = {
  retracedId: 'amfori_client_id',
  name: 'amfori Client ID',
  description:
    'OAuth2 client identifier used to authenticate Retraced against the amfori API on behalf of a partner.',
  meta: {integration: 'AMFORI'},
  fieldTypeId: 'SHORT_TEXT',
  type: 'GLOBAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [],
  sortingId: 37820,
  sectionId: '1.2',
  impactArea: 'Other IDs',
  impactAreaId: 'OTHER_IDS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
